module.exports = __webpack_public_path__ + "img/ico-share02.caff3d1e.svg";